import type { ArcgisMapView } from './arcgisView';

export function zoomMapViewToLocation({
  mapView,
  longitude,
  latitude,
  zoom,
}: {
  mapView: ArcgisMapView | null;
  longitude: number;
  latitude: number;
  zoom?: number;
}) {
  if (!mapView) return;

  if (zoom) {
    return mapView.goTo(
      { center: [longitude, latitude], zoom },
      { duration: 500 }
    );
  } else {
    return mapView.goTo({ center: [longitude, latitude] }, { duration: 500 });
  }
}

export function zoomMapViewToGraphic({
  mapView,
  graphic,
  zoom,
}: {
  mapView: ArcgisMapView | null;
  graphic: __esri.Graphic;
  zoom?: number;
}) {
  if (!mapView || !graphic.geometry) {
    return;
  }

  if (zoom) {
    return mapView.goTo({ target: graphic.geometry, zoom }, { duration: 500 });
  } else {
    return mapView.goTo({ target: graphic.geometry }, { duration: 500 });
  }
}
